<nz-input-group class="search-input" [nzSuffix]="suffixIconSearch">
  <input
    #autoInput
    nz-input
    [nzAutocomplete]="auto"
    [placeholder]="placeholder"
    [ngModel]="searchCustomer"
    (ngModelChange)="searchCust($event)"
    (focus)="onSearchInputFocus()"
    (blur)="hiddenSearch()"
  />
</nz-input-group>

<ng-template #suffixIconSearch>
  <i
    *ngIf="!isWithholdingSearching"
    nz-icon
    nzType="search"
    style="color: #838383; margin-top: -9px"
  ></i>
  <i
    *ngIf="isWithholdingSearching"
    nz-icon
    nzType="loading"
    style="color: #838383; margin-top: -9px"
  ></i>
</ng-template>

<nz-autocomplete
  #auto
  [nzDefaultActiveFirstOption]="true"
  [nzOverlayClassName]="'search-auto-panel'"
  (selectionChange)="onSelectOption($event)"
>
  <ng-container [ngSwitch]="getSearchDisplayType()">
    <!-- 空值时显示历史记录 -->
    <ng-container *ngSwitchCase="'history'">
      <nz-auto-option
        *ngFor="let item of searchHistoryList; let i = index"
        [ngClass]="{ 'list-hover': curHoverList === i }"
        [nzValue]="{ event: item, isHistory: true }"
        [nzLabel]="magicLabel"
      >
        <i nz-icon nzType="clock-circle" style="margin-right: 8px"></i>
        <ng-container
          *ngTemplateOutlet="custOptionTpl; context: { $implicit: item }"
        ></ng-container>
      </nz-auto-option>
    </ng-container>
    <!-- 显示搜索结果 -->
    <ng-container *ngSwitchCase="'result'">
      <nz-auto-option
        *ngFor="let item of custSearchResultList; let i = index"
        [ngClass]="{ 'list-hover': curHoverList === i }"
        [nzValue]="item"
        [nzLabel]="magicLabel"
      >
        <ng-container
          *ngTemplateOutlet="custOptionTpl; context: { $implicit: item }"
        ></ng-container>
      </nz-auto-option>
    </ng-container>
    <!-- 正在加载 -->
    <nz-auto-option
      *ngSwitchCase="'loading'"
      [nzDisabled]="true"
      [nzValue]="null"
      class="empty-auto-option-wrapper"
    >
      <nz-empty
        class="empty-auto-option"
        [nzNotFoundContent]="'正在搜索，请稍候...'"
        [nzNotFoundImage]="'../assets/images/auto-empty.png'"
      ></nz-empty>
    </nz-auto-option>
    <!-- 没有搜索到内容 -->
    <nz-auto-option
      *ngSwitchCase="'empty'"
      [nzDisabled]="true"
      [nzValue]="null"
      class="empty-auto-option-wrapper"
    >
      <nz-empty
        class="empty-auto-option"
        [nzNotFoundContent]="'没有找到匹配项'"
        [nzNotFoundImage]="'../assets/images/auto-empty.png'"
      ></nz-empty>
    </nz-auto-option>
  </ng-container>
</nz-autocomplete>

<ng-template #custOptionTpl let-item>
  <span *ngIf="getCustStateLabel(item.custState) as label" class="state-icon-text">
    {{ label }}
  </span>
  {{ item.custCode }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ item.custName }}&nbsp;&nbsp;|&nbsp;&nbsp;
  {{ item.custAddress }}&nbsp;&nbsp;|&nbsp;&nbsp;
  {{ item.bookCode }}
</ng-template>
